/*
Copyright 2021 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
*/
export default {
  // `true` to allow navigation to /system/analytics and `false` not to.
  showsAnalytics: true,
  home: {
    title: null,
    body: null
  },
  oidcEnabled: process.env.VUE_APP_OIDC_ENABLED === 'true',
  showsFeedbackButton: false
};
